/**
 * A labeled group of form fields.
 *
 * @export
 * @class FormFieldGroup
 */
export class FormFieldGroup {
  /**
   * Creates an instance of FormFieldGroup.
   * @param {any} {name, fields = []}
   * @memberof FormFieldGroup
   */
  constructor ({ name, fields = [], layout = {}, fieldTemplate }) {
    this.name = name
    this.fields = fields
    this.layout = layout
    if (fieldTemplate) {
      this.fieldTemplate = fieldTemplate
    }
  }
}
